import React, { useState } from "react";

// Add location details
const locationDetails = {
  tvm: {
    details: [
      ".  ECHS Polyclinic, Pangode Thiruvananthapuram was raised on 01 Apr 2004 and was initially loc in a barrack, opp to MH Thiruvananthapuram.  It is one km  from Stn HQ Thiruvananthapuram.  Permt bldg inaugurated on 28 Dec 2006 in A1 Def land.  It is presently the only Type Á’ Polyclinic in Kerala with more than 60,000 registered ECHS beneficiaries with an average footfall of about 560 patient per day. Looking after Neyyattinkara, Kattakada, Nedumangadu and parts of Chirayinkeezhu and VarkalaTaluks Thiruvananthapuram District.",
    ],
  },
  tmc: {
    details: [
      "ECHS Polyclinic Trivandrum (Medical College) was raised at Prashant Nagar, Trivandrum on 01 March 2012. Consultation commenced wef  01 Apr 2012 with two Medical Offrs and 07 staff under OIC, Col M G Harimohan. The Polyclinic was relocated to the present hired building at Pulayanarkotta on 01 Apr 2017. Presently the Polyclinic has dependency of 14579 veterans and dependents. 25 cents of land allotted by Sate Govt is awaiting approval of MoD for taking over.",
    ],
  },
  tuticorin: {
    details: [
      "ECHS Polyclinic at Tuticorin was established on 26 Mar 2006. The Polyclinic is administratively under Stn HQ, Pangode (Trivandrum) and technically under Regional Centre ECHS, Trivandrum.  The Policlinic was initially set up in a rented house at Chidambara Nagar, Tuticorin. The Polyclinic was shifted to the present location, i.e. First Floor of No 5G/7&8, Ganesh Nagar, Tuticorin wef 09 Jun 2014. The ground floor is occupied by Extension Counter of Golden Palm Canteen, Tirunelveli. There are 8314 ECHS beneficiaries dependent on the polyclinic",
    ],
  },
  ranni: {
    details: [
      "The ECHS Polyclinic Ranni was est at Pazhavangadi, Ranni wef 18 Oct 2010. The Polyclinic commenced op wef 23 Sep 2013, in a rented bldg, and was formally inaugurated by Lt Gen V K Pillai, AVSM, SM, GOC ATNK & K Area on                    20 Nov 2013. The Polyclinic has a beneficiary str of 8,582 incl 3677 ESM/widows and 4905 dependents with an average footfall of about 140-150 patient per day. Looking after Ranni, Kozhencherry, Manapplly, Thiruvalla & Kanjirapally Tehsils.",
    ],
  },
  kilimanoor: {
    details: [
      "ECHS Polyclinic, Kilimanoor was raised in the present (rented) building wef 01 Jun 2013 with a monthly rent of Rs 24,900/-. Col Raveendran Pillai (Retd) was appointed as the first OIC.   Lt Gen VK Pillai, AVSM,SM, GOC Dakshin Bharat Area inaugurated the Polyclinic on 12 Aug 2013.   The Polyclinic covers the Taluks of Varkala, Chirayinkeezhu, Nedumangadu and part of Kottarakkara in Trivandrum and Kollam districts. ",
    ],
  },
  pathanamthitta: {
    details: [
      ".  ECHS Polyclinic Pathanamthitta was raised on 01 Apr 2005 at Omallur, Pathanamthitta District.  It moved to the present loc, i.e, Thumpamon (hired bldg, belongs to St Marys Orthodox Church, Thumpamon) on 01 Nov 2010.  The Polyclinicis having more than 29,000 registered ECHS beneficiaries with an average footfall of about 350 patients per day.  Resp for providing ECHS benefits to the beneficiaries belongs to Pandalam, Adoor, Kozhencherry, Konni and Pathanamthitta.",
    ],
  },
  changanacherry: {
    details: [
      "ECHS Polyclinic, Changanassery started functioning wef                      09 Jul 2012. It has a beneficiary strength of 13835 including 5239 ESM/Widows and             8596 dependents. This Polyclinic is administratively under Stn HQ / RC ECHS Thiruvananthapuram and for technical support under CO, INHS Sanjivani (SEMO/SEDO). This Polyclinic is mainly looking after the medical care of Ex servicemen and dependent from Changanassery and Kanjirappaly Taluk of Kottayam Dist, Mallappally and Thiruvalla Taluk of Pathanamthitta Dist, Kuttanad Taluk of Alappuzha Dist and other adjoining areas of Edukki Dist as on date.",
    ],
  },
  mavelikara: {
    details: [
      "ECHS Polyclinic Mavelikara was sanctioned by the Ministry of Defence wef                 01 Mar 2012.  The Polyclinic commenced its operations wef 01 Apr 2012 in a small building provided by the MavelikaraMunicipality at Park Jn. Within two year’s time, the str of registered members rose to 7493 and presently there are 38080 registered members. The Polyclinic is geographically designed to look after veterans of Karthikappally, Mavelikara and Chengannur Taluks of Alappuzha Dist.  However, due to excellent bus connectivity, ESM from Taluks of Thiruvalla, Pandalam, Adoor and Karunagapally are utilising the facilities of this Polyclinic.",
    ],
  },
  nagercoil: {
    details: [
      "ECHS Polyclinic at Nagercoil established in Phase-III to provide comprehensive Medicare to all Armed Forces Veterans (AFV) pensioners, their widows and authorized dependents mainly of Kanyakumari District, under Stn HQ Trivandrum. This polyclinic was inaugurated on 29 March 2006 in a hired accommodation, with authorized medical and paramedical staff at Vetturnimadom, Nagercoil, KanyakumariDist (Tamil Nadu).",
    ],
  },
  kottarakara: {
    details: [
      "ECHS Polyclinic, Kollam was raised on 29 Mar 2006 in a hired building in Jonakapuram, Kollam and further shifted to another hired building at Eravipuram, Kollam on 28 Mar 2009.  Finally, ECHS Polyclinic Kollam shifted to its own permt bldg at Kundara on 29 Sep 2018.  The land for the bldg acquired on lease from Govt of  Kerala for 30 years.The Polyclinic is with more than 28,706 registered ECHS beneficiaries with an average footfall of about 322 patient per day.This provides ECHS facilities to Veterans and 	dependents of Kollam, Karunagappally and Kunnathur Taluk of western part of Kollam district.",
    ],
  },
  kollam: {
    details: [
      "ECHS Polyclinic, Kollam was raised on 29 Mar 2006 in a hired building in Jonakapuram, Kollam and further shifted to another hired building at Eravipuram, Kollam on 28 Mar 2009.  Finally, ECHS Polyclinic Kollam shifted to its own permt bldg at Kundara on 29 Sep 2018.  The land for the bldg acquired on lease from Govt of  Kerala for 30 years.The Polyclinic is with more than 28,706 registered ECHS beneficiaries with an average footfall of about 322 patient per day.This provides ECHS facilities to Veterans and 	dependents of Kollam, Karunagappally and Kunnathur Taluk of western part of Kollam district.",
    ],
  },
};

const locations = [
  { id: "tvm", label: "TVM" },
  { id: "tmc", label: "TMC" },
  { id: "tuticorin", label: "TUTICORIN" },
  { id: "ranni", label: "RANNI" },
  { id: "kilimanoor", label: "KILIMANOOR" },
  { id: "pathanamthitta", label: "PATHANAMTHITTA" },
  { id: "changanacherry", label: "CHANGANACHERRY" },
  { id: "mavelikara", label: "MAVELIKARA" },
  { id: "nagercoil", label: "NAGERCOIL" },
  { id: "kottarakara", label: "KOTTARAKARA" },
  { id: "kollam", label: "KOLLAM" },
];

const galleryImages = [
  {
    id: 1,
    src: "assets/img/polyclinic/PANG.jpg",
    location: "tvm",
    category: "drinks events",
  },
  {
    id: 2,
    src: "assets/img/polyclinic/TMC.jpg",
    location: "tmc",
    category: "events",
  },
  {
    id: 3,
    src: "assets/img/polyclinic/KLM.jpg",
    location: "kollam",
    category: "drinks foods",
  },
  {
    id: 4,
    src: "assets/img/polyclinic/CHANG.jpg",
    location: "changanacherry",
    category: "events",
  },
  {
    id: 5,
    src: "assets/img/polyclinic/KILI.jpg",
    location: "kilimanoor",
    category: "pastries events",
  },
  {
    id: 6,
    src: "assets/img/polyclinic/KTR.jpg",
    location: "kottarakara",
    category: "foods",
  },
  {
    id: 7,
    src: "assets/img/polyclinic/NGL.jpg",
    location: "nagercoil",
    category: "foods drinks",
  },
  {
    id: 8,
    src: "assets/img/polyclinic/mvl.png",
    location: "mavelikara",
    category: "pastries",
  },
  {
    id: 9,
    src: "assets/img/polyclinic/PC.png",
    location: "",
    category: "events",
  },
  {
    id: 10,
    src: "assets/img/polyclinic/PTA.jpg",
    location: "pathanamthitta",
    category: "foods",
  },
  {
    id: 11,
    src: "assets/img/polyclinic/RANNI.jpg",
    location: "ranni",
    category: "drinks",
  },
  {
    id: 12,
    src: "assets/img/polyclinic/TTCN.jpg",
    location: "tuticorin",
    category: "foods",
  },
];

const Polyclinics = () => {
  const [activeFilter, setActiveFilter] = useState("tvm");

  const filteredImages = galleryImages.filter(
    (img) => img.location === activeFilter
  );

  const FilterButton = ({ id, label, isActive }) => (
    <li className="inline">
      {id !== "tvm" && (
        <span className="inline-block w-1 h-1 ml-2 mr-3 my-0 rounded-full bg-[rgba(30,34,40,0.2)] align-middle" />
      )}
      <button
        className={`filter-item uppercase tracking-[0.02rem] text-[0.7rem] font-bold ${
          isActive ? "text-[#3f78e0]" : "text-[#aab0bc]"
        } cursor-pointer hover:text-[#3f78e0]`}
        onClick={() => setActiveFilter(id)}
      >
        {label}
      </button>
    </li>
  );

  return (
    <div>
      <section className="wrapper bg-[#edf2fc]">
        <div className="container pt-10 pb-10 xl:pt-[4.5rem] lg:pt-[4.5rem] md:pt-[4.5rem] xl:pb-15 lg:pb-15 md:pb-15 text-center">
          <div className="flex flex-wrap mx-[-15px]">
            <div className="md:w-10/12 lg:w-8/12 xl:w-8/12 w-full flex-[0_0_auto] px-[15px] max-w-full mx-auto">
              <h1 className="text-[calc(1.365rem_+_1.38vw)] font-bold leading-[1.2] xl:text-[2.4rem] mb-3">
                Polyclinics
              </h1>
              <p className="lead lg:px-5 xl:px-5 leading-[1.65] text-[0.9rem] font-medium max-w-full">
                Polyclinics under StnHq Tvm
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="pt-10 xl:pt-10 wrapper bg-white border-b border-[rgba(164,174,198,0.2)]">
        <div className="container text-center">
          <div className="itemgrid grid-view">
            <div className="isotope-filter relative z-[5] filter mb-10">
              <ul className="inline m-0 p-0 list-none">
                {locations.map(({ id, label }) => (
                  <FilterButton
                    key={id}
                    id={id}
                    label={label}
                    isActive={activeFilter === id}
                  />
                ))}
              </ul>
            </div>

            {/* Location Details Card - Using Tailwind classes */}
            <div className="mb-8 bg-white rounded-lg shadow-md border border-gray-200">
              <div className="p-6">
                <h3 className="text-lg font-semibold mb-4 text-gray-800">
                  {locations.find((loc) => loc.id === activeFilter)?.label}
                </h3>

                {/* Images Section */}
                <div className="flex flex-wrap mx-[-15px] justify-center">
                  {filteredImages.map((image) => (
                    <div
                      key={image.id}
                      className="xl:w-4/12 lg:w-4/12 md:w-6/12 w-full flex-[0_0_auto] px-[15px] mt-[30px] max-w-full"
                    >
                      <figure>
                        <a className="relative block z-[3] cursor-pointer h-64">
                          <img
                            src={image.src}
                            alt={`ECHS Polyclinic ${image.location.toUpperCase()}`}
                            className="w-full h-full object-cover rounded"
                          />
                        </a>
                      </figure>
                    </div>
                  ))}
                </div>

                {/* Details Section */}
                <ul className="list-disc pl-6 space-y-2 text-left mt-6">
                  {locationDetails[activeFilter].details.map(
                    (detail, index) => (
                      <li key={index} className="text-sm text-gray-600">
                        {detail}
                      </li>
                    )
                  )}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Polyclinics;
